import styled from "styled-components";

export const TextColor = styled.div`
  background: #F12E11;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
`;

const BorderColor = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 16px 20px;
  background: #F12E11;

  &:before {
    content: "";
    position: absolute;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    top: 1px;
    left: 1px;
    background-color: #f5f5f5;
    z-index: 1;
    border-radius: 13px;
  }

  & > div {
    z-index: 2;
    border-radius: 15px;
    margin: 0 !important;
    flex: 1;
    text-align: center;
    align-items: center;
    justify-content: center;
  }
`;

export const ButtonColor = (props) => {
    return (
        <BorderColor {...props}>
            <TextColor {...props}>{props.children}</TextColor>
        </BorderColor>
    )
}